/**
 * L'ouvrage dont l'énoncé a été découpé, nommé à côté de son image.
 *
 * Demandé par Hedi le 15 septembre 2026 : *« montre aux parents (ce qui sera
 * proposé) et aux enfant le parascolaire coupé au lieu de la transcription.
 * Indique le également avec une étiquette coloré avec le nom du parascolaire
 * utilisé. »*
 *
 * **Le titre entier, jamais raccourci.** `nom_du_parascolaire` rend ce que le
 * manifeste du découpage porte — « Chouette — Dictées, la compil' 6ᵉ-3ᵉ (Sophie
 * Valle, Hatier) » — et c'est le seul état où l'étiquette sert à quelque chose :
 * un titre coupé nomme un livre que personne ne reconnaît sur l'étagère. Elle
 * s'enroule donc, à la différence des autres étiquettes, qui portent un mot.
 *
 * **Partagée entre les deux coquilles**, dans `ui/` : l'enfant la voit au-dessus
 * de son énoncé, le parent au-dessus du même énoncé sur « Ce qui lui sera
 * proposé ». Écrite deux fois, la phrase aurait fini par différer d'un écran à
 * l'autre — et c'est la même information.
 *
 * Elle accompagne l'image et **jamais la transcription** : c'est l'appelant qui
 * tient cette règle, l'étiquette ne sachant pas ce qu'il y a en dessous.
 */

export function EtiquetteParascolaire({ nom }: { nom: string | null | undefined }) {
  const titre = (nom ?? "").trim();
  if (!titre) return null;
  return (
    <p className="parascolaire">
      {/* Le titre seul à l'écran, la phrase entière pour un lecteur d'écran :
          hors contexte, « Chouette — Dictées » ne dit pas que c'est la
          provenance de l'exercice qui vient d'être lu. */}
      <span className="chip" data-nature="parascolaire" aria-label={`Exercice tiré de ${titre}`}>
        {titre}
      </span>
    </p>
  );
}
